import React, { Component, useState, useRef, Fragment } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, DatePicker } from 'antd'
import styles from './workerDialog.module.scss'
import dayjs from 'dayjs'
import * as actions from '@/models/workers/actions'
import * as apis from '@/apis'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class ServiceTimeForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { submit } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          console.log('errors', errors)
          errors.forEach(({ message: msg }) => {
            console.log('msg:', msg)
            message.error(msg)
          })
        })
        return console.error(err)
      }

      values.service_time = values.service_time.valueOf()

      submit(values)
    });
  }

  render() {
    const { id, order } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form

    // 更改上门时间给用户发短信通知
    console.log('xxx:', order.get('service_time') ? dayjs(order.get('service_time')) : null)

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="预约时间"
            extra="更改上门时间，务必跟师傅线下确认上门时间后再更改。请勿频繁更改，务必谨慎操作"
            required>
            {getFieldDecorator('service_time', {
              initialValue: order.get('service_time') ? dayjs(order.get('service_time')) : null,
              rules: [
                {
                  required: true,
                  message: '请选择上门时间',
                },
              ],
            })(
              <DatePicker
                showTime={{ format: 'HH:mm', minuteStep: 5 }}
                format="YYYY-MM-DD HH:mm"
                placeholder="选择上门时间" />
            )}
          </Form.Item>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">
              更改
            </Button>
          </div>
        </Form>
      </div>
    )
  }
}

const ChangeServiceTimeDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={500}
    centered
    visible={isOpen}
    onCancel={hide}

    mask={false}
    wrapClassName="order-detail-modal-wrap"
    maskStyle={{ position: 'absolute' }}
    getContainer={() => document.getElementById('order-detail-wrap') || window}
  >
    <ServiceTimeForm submit={submit} {...ownProps} />
  </Modal >
)

export default sagaModal({
  name: 'SERVICE_TIME_DIALOG',
})(ChangeServiceTimeDialog)
